import {CrazyGamesAdsType} from "../CrazyGamesAds/CrazyGamesAds";

export enum ADS_TYPE {
    REWARDED = 'rewarded',
    INTERSTITIAL = 'interstitial',
    BANNER = 'banner',
}

export const AzerionAdsAssoc = {
    [ADS_TYPE.INTERSTITIAL]: 'interstitial',
    [ADS_TYPE.REWARDED]: 'rewarded',
    [ADS_TYPE.BANNER]: 'display',
}